import React from 'react';

interface Props {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const SectionHeader = ({title, subtitle, className, onClick}: Props) => (
  <header
    className={`college-profile-section-header ${className ? className : ''}`}
    onClick={onClick}
  >
    <div className="college-profile-section-header-title">{title}</div>
    <div className="college-profile-section-header-subtitle">{subtitle}</div>
  </header>
);

export default SectionHeader;
